import { ButtonProps } from 'antd';

export const fastActionBtnProps: ButtonProps = {
  color: 'cyan',
  variant: 'outlined',
};
